import { Box, Typography, styled, Grid, useMediaQuery } from "@mui/material";
import color from "../../components/utils/Colors";
import { useEffect, useState } from "react";
import { useUser } from "../../services/Context/UserContext";
import { getProfile } from "../../services/services";

const ProfileDetails = () => {
  const { user } = useUser();
  const isSmallScreen2 = useMediaQuery("(max-width:600px)");
  const [phone, setPhone] = useState("");

  // Fetch full profile to get phone number not stored in UserContext
  useEffect(() => {
    getProfile()
      .then((res: any) => {
        const data = res?.data?.data ?? res?.data ?? {};
        setPhone(data.phone ?? data.phoneNumber ?? data.mobile ?? "");
      })
      .catch(() => {
        // silently fallback to empty
      });
  }, [user?.id]);

  const CustomTypo = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "14px" : "20px",
    width: isSmallScreen2 ? "40%" : "25%",
    fontWeight: "bold",
    marginTop: "10px",
    height: "100%",
    display: "flex",
    alignItems: "center",
  });

  const CustomTypo1 = styled(Typography)({
    color: color.textColor,
    fontSize: isSmallScreen2 ? "14px" : "20px",
    width: isSmallScreen2 ? "40%" : "75%",
    marginTop: "10px",
    height: "100%",
    display: "flex",
    alignItems: "center",
    overflow: "auto",
    whiteSpace: "nowrap",
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      background: color.secondColor,
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: color.firstColor,
      border: "solid 1px white",
      borderRadius: "10px",
    },
  });

  return (
    <>
      <Box
        sx={(theme) => ({
          marginTop: "25px",
          flex: 1,
          p: "3%",
          borderRadius: "16px",
          boxShadow: 2,
          bgcolor:
            theme.palette.mode === "light" ? "#faecfa71" : "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(2px)",
        })}
      >
        <Grid
          container
          spacing={2}
          sx={{ py: 1, pl: isSmallScreen2 ? 1 : 4, pb: 2 }}
        >
          <Grid item xs={12} md={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Name :</CustomTypo>
              <CustomTypo1>{user?.name}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Email Id :</CustomTypo>
              <CustomTypo1>{user?.email}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Phone Number :</CustomTypo>
              <CustomTypo1>{phone || "—"}</CustomTypo1>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mb: 0 }}>
              <CustomTypo>Role :</CustomTypo>
              <CustomTypo1>{user?.role || "—"}</CustomTypo1>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ProfileDetails;
